import * as THREE from "three";

export default function(x, y, z, hero, textureLoader) {
  /*
   * @function - Halo
   * Creates halo element to add to weapon
   * @param - x2 (Number): X position of halo
   * @param - y2 (Number): Y position of halo
   * @param - z2 (Number): Z position of halo
   * @param - material (ThreeJS Material Instance): Material to use
   */
  function Halo(x2, y2, z2, material) {
    Object.setPrototypeOf(this, new THREE.Object3D());
    this.position.set(x2, y2, z2);

    const geometry = new THREE.CylinderBufferGeometry(0.7, 0, 12);
    const mesh = new THREE.Mesh(geometry, material);

    this.add(mesh);
  }

  /*
   * @function - Ray
   * Creates ray element to add to villain
   * @param - x2 (Number): X position of ray
   * @param - y2 (Number): Y position of ray
   * @param - z2 (Number): Z position of ray
   * @param - rotx (Number): X rotation of ray
   * @param - material (ThreeJS Material Instance): Material to use
   */
  function Ray(x2, y2, z2, rotz, material) {
    Object.setPrototypeOf(this, new THREE.Object3D());
    this.position.set(x2, y2, z2);
    this.rotation.z = rotz;

    const geometry = new THREE.CylinderBufferGeometry(0, 0.1, 0.25);
    const mesh = new THREE.Mesh(geometry, material);

    this.add(mesh);
  }

  /*
   * @function - Center
   * Creates center element to add to villain
   * @param - material (ThreeJS Material Instance): Material to use
   */
  function Center(material) {
    Object.setPrototypeOf(this, new THREE.Object3D());

    const geometry = new THREE.SphereBufferGeometry(0.25);
    const mesh = new THREE.Mesh(geometry, material);

    this.add(mesh);
  }

  Object.setPrototypeOf(this, new THREE.Object3D());
  this.name = "Weapon";
  this.position.x = x;
  this.position.z = z;
  this.position.y = 0.3;

  const textureThunder = textureLoader.load("/img/3DTextures/xterminate/game/thunder.jpeg");
  const textureThunder2 = textureLoader.load("/img/3DTextures/xterminate/game/thunder2.jpg");
  const textureSun = textureLoader.load("/img/3DTextures/xterminate/game/sun.jpg");

  const materialThunder = new THREE.MeshPhongMaterial({
    map: textureThunder,
    transparent: true,
    opacity: 0.6
  });
  const materialThunder2 = new THREE.MeshPhongMaterial({ map: textureThunder2 });
  const materialSun = new THREE.MeshPhongMaterial({ map: textureSun });

  const halo = new Halo(0, 7, 0, materialThunder);
  const center = new Center(materialSun);
  const ray1 = new Ray(0.285, 0.285, 0, -Math.PI / 4, materialThunder2);
  const ray2 = new Ray(-0.285, 0.285, 0, Math.PI / 4, materialThunder2);
  const ray3 = new Ray(0.395, 0, 0, -Math.PI / 2, materialThunder2);
  const ray4 = new Ray(-0.395, 0, 0, Math.PI / 2, materialThunder2);
  const ray5 = new Ray(0.285, -0.285, 0, -Math.PI * (3 / 4), materialThunder2);
  const ray6 = new Ray(-0.285, -0.285, 0, Math.PI * (3 / 4), materialThunder2);
  const ray7 = new Ray(0, 0.395, 0, 0, materialThunder2);
  const ray8 = new Ray(0, -0.395, 0, Math.PI, materialThunder2);

  this.add(halo);
  this.add(center);
  this.add(ray1);
  this.add(ray2);
  this.add(ray3);
  this.add(ray4);
  this.add(ray5);
  this.add(ray6);
  this.add(ray7);
  this.add(ray8);

  const numWeapon = 1;

  /*
   * @function - perform
   * Action of agents oriented programming 3d interfaces
   * @param - scene (ThreeJS Scene Instance): Scene instance of the 3d scene
   */
  function perform() {
    if (
      Math.abs(hero.position.x - this.position.x) < 0.5 &&
      Math.abs(hero.position.z - this.position.z) < 0.5 &&
      !!this.visible
    ) {
      this.visible = false;
      hero.charge(numWeapon);
    }

    if (
      Math.abs(hero.position.x - this.position.x) + Math.abs(hero.position.z - this.position.z) >
        42 &&
      !this.visible
    ) {
      this.visible = true;
    }

    if (
      Math.abs(this.position.x - hero.position.x) + Math.abs(this.position.z - hero.position.z) <=
      5
    ) {
      this.rotation.y += 0.05;
    }
  }

  this.perform = perform;
}
